export const actionTypes = {
  FETCH_PERSON_CHECK_INS_HISTORY: 'MEMBER_PORTAL/FETCH_PERSON_CHECK_INS_HISTORY',
  FETCH_PERSON_RECENT_CHECK_INS_HISTORY: 'MEMBER_PORTAL/FETCH_PERSON_RECENT_CHECK_INS_HISTORY',
  SET_PERSON_CHECK_INS_HISTORY_LOADING: 'MEMBER_PORTAL/SET_PERSON_CHECK_INS_HISTORY_LOADING',
  SET_PERSON_RECENT_CHECK_INS_HISTORY_LOADING:
    'MEMBER_PORTAL/SET_PERSON_RECENT_CHECK_INS_HISTORY_LOADING',
};
